const CLOUDINARY_MARKER = '/image/upload/';

export function isCloudinaryImageUrl(value) {
  return typeof value === 'string'
    && value.includes('res.cloudinary.com/')
    && value.includes(CLOUDINARY_MARKER);
}

export function collectCloudinaryUrls(value, found = new Set(), key = '') {
  if (key === '_cloudinaryAssets') return found;
  if (Array.isArray(value)) {
    value.forEach((item) => collectCloudinaryUrls(item, found));
    return found;
  }
  if (value && typeof value === 'object') {
    Object.entries(value).forEach(([childKey, item]) => collectCloudinaryUrls(item, found, childKey));
    return found;
  }
  if (isCloudinaryImageUrl(value)) found.add(value);
  return found;
}

export function buildManagedAssetList(record, pendingUploads = [], previousAssets = []) {
  const urls = collectCloudinaryUrls(record);
  const metadataByUrl = new Map();

  [...(previousAssets || []), ...(pendingUploads || [])].forEach((asset) => {
    if (asset?.url) metadataByUrl.set(asset.url, asset);
  });

  return [...urls].map((url) => {
    const known = metadataByUrl.get(url);
    return known
      ? { url, publicId: known.publicId || '' }
      : { url };
  });
}

export function splitPendingUploads(record, pendingUploads = []) {
  const usedUrls = collectCloudinaryUrls(record);
  return {
    used: pendingUploads.filter((asset) => usedUrls.has(asset.url)),
    unused: pendingUploads.filter((asset) => !usedUrls.has(asset.url)),
  };
}

export function buildMediaSnapshot(record) {
  if (!record) return null;
  return {
    urls: [...collectCloudinaryUrls(record)],
    assets: Array.isArray(record._cloudinaryAssets)
      ? record._cloudinaryAssets.map((asset) => ({
        url: String(asset?.url || ''),
        publicId: String(asset?.publicId || ''),
      }))
      : [],
  };
}
